import type { WorkflowOptions } from '../../types';
import { addOriginWorkflow } from './addOriginWorkflow';
import { editOriginWorkflow } from './editOriginAddressWorkflow';
import { generateAssetStatusWorkflow } from '../generateAssetStatusWorkflows';

export const workflows: WorkflowOptions[] = [
  addOriginWorkflow,
  editOriginWorkflow,
  ...Object.values(generateAssetStatusWorkflow('origin')),
];

export default workflows;
